import { Injectable } from '@angular/core';
import { HierarchicalPermissionDto } from './iamapi/iamapi.services';

@Injectable({
  providedIn: 'root'
})
export class HierarchicalPermissionsService {

  public userPermissions: HierarchicalPermissionDto;

  constructor() { }
}
